import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'app-card-target',
  templateUrl: './card-target.component.html',
  styleUrls: ['./card-target.component.scss'],
})
export class CardTargetComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() target: number;
  @Input() value: number;
  @Input() isInverted: boolean = false;
  @Input() targetText: string = 'requested';
  @Input() reverseTargetTextDirection: boolean = false;
  @Input() icon: string;
  @Input() failedBackground: string = 'error-sim';
  @ViewChild('progressTarget') progressTarget: ElementRef<HTMLDivElement>;

  get ratio(): number {
    return this.value / this.target;
  }

  constructor() {
    this.handleDidResize = this.handleDidResize.bind(this);
  }

  ngOnInit(): void {
    document.addEventListener('resize', this.handleDidResize);
  }

  ngOnDestroy(): void {
    document.removeEventListener('resize', this.handleDidResize);
  }

  ngAfterViewInit(): void {
    this.handleDidResize();
    this.progressTarget.nativeElement.style.transitionDuration = '300ms';
  }

  handleDidResize() {
    const progressTargetEl = this.progressTarget.nativeElement;
    const progressTargetWidth = progressTargetEl.getBoundingClientRect().width;
    const offset = Math.max(progressTargetWidth / 2, 16);
    progressTargetEl.parentElement.style.setProperty(
      '--widthOffset',
      offset + 'px'
    );
  }

  getBgClassFromTargetRatio(ratio: number) {
    if (ratio < 1 || (ratio === 1 && this.isInverted)) {
      return !this.isInverted ? this.failedBackground : 'success-sim';
    } else {
      return !this.isInverted ? 'success-sim' : this.failedBackground;
    }
  }

  getTargetOffsetFromRatio(ratio: number): number {
    return Math.min(ratio > 1 ? 1 - 1 / ratio : 0, 1);
  }

  getTargetOffset() {
    const targetWidth =
      this.progressTarget?.nativeElement.getBoundingClientRect().width / 2;
    const parent = this.progressTarget?.nativeElement.parentElement;
    const barWidth = parent?.getBoundingClientRect().width;
    const progressOffset = parent?.style.getPropertyValue('--widthOffset');

    const offset =
      this.getTargetOffsetFromRatio(this.ratio) * barWidth -
      targetWidth +
      parseInt(progressOffset);
    return Math.min(offset, barWidth - targetWidth * 2);
  }

  getTrailOffsetFromRatio(ratio: number) {
    return Math.min(ratio, 1);
  }
}

@Component({
  selector: 'app-card-subtitle',
  template: '<ng-content></ng-content>',
})
export class AppCardSubtitleComponent {}
